
import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    currentBid: 'Current bid',
    timeRemaining: 'Time remaining',
    ended: 'Ended',
  },
  ru: {
    currentBid: 'Текущая ставка',
    timeRemaining: 'Осталось времени',
    ended: 'Завершен',
  },
  uz: {
    currentBid: 'Joriy takif',
    timeRemaining: 'Qolgan vaqt',
    ended: 'Tugadi',
  },
});
